import "../styles/main.css"
import { initfiltering } from "./filtering"
import { initNavbar } from "./navbar"
import { initTeamCarousel } from "./embla"
import { initServiceCarousel } from "./embla"

document.addEventListener("DOMContentLoaded", async () => {
  initNavbar()
  if (window.location.href.includes("/realisations/")) {
    initfiltering()
  }
  if (window.location.href.includes("studio")) {
    initTeamCarousel()
  }
  if (window.location.href.includes("/service/")) {
    initServiceCarousel()
  }
})